import { VueModule } from '@Foundation';
import StarReview from './code/Scripts/components/star-review';

export default VueModule({
  components: {
    StarReview
  }
});
